import { Fighter } from "./Fighter";

export class NavigationInfo {
  teamId!: string;
  teamName!: string;
  fighters!: {
    id: string;
    name: string;
  }[];
}
